import React, { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';

interface Props {
    title?: string;
    children: ReactNode;
    open: boolean;
}

const Step = ({ title, children, open }: Props): JSX.Element => {
    const stepId = uuid();

    return (
        <div className="step" id={stepId}>
            {open && (
                <>
                    {title && <h1>{title}</h1>}
                    {children}
                </>
            )}
        </div>
    );
};

export default Step;
